/* src/app/shared/components/ship-details-actions/ship-details-actions.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-details-actions ul.actions {
  padding: 0;
  margin: 0 -1.5rem;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.ship-details-actions ul.actions li.action {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  width: auto;
  min-width: 3.5rem;
  margin-bottom: 1rem;
}
@media screen and (min-width: 48rem) {
  .ship-details-actions ul.actions li.action {
    width: auto;
    min-width: 5rem;
    max-width: 5rem;
    margin-bottom: 0;
  }
}
@media screen and (min-width: 48rem) {
  .ship-details-actions ul.actions li.action.button-container {
    max-width: unset;
  }
}
.ship-details-actions ul.actions li.action:hover .action-label {
  font-weight: 700;
}
.ship-details-actions ul.actions li.action .action-icon {
  margin-bottom: 0.625rem;
  height: 1.75rem;
}
.ship-details-actions ul.actions li.action .action-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  color: #004791;
  font-size: 0.75rem;
  max-width: 6.35rem;
  line-height: 1.5;
  word-break: break-word;
}
.ship-details-actions ul.actions li.action .action-button {
  font-size: 0.75rem;
  height: 2.1875rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ship-details-actions ul.actions li.action img {
  transform: scale(1);
  transition: transform 0.15s ease-in-out;
}
.ship-details-actions ul.actions li.action:hover img {
  transform: scale(1.2);
}
.ship-details-actions ul.actions li.divider {
  width: 0;
}
@media screen and (min-width: 48rem) {
  .ship-details-actions ul.actions li.divider {
    width: 0;
  }
}
/*# sourceMappingURL=ship-details-actions.component.css.map */
